<template>
  <div
    class="main-menu"
    :style="{ 
      '--sidebar-width': sidebarWidth,
      '--height': height,
      '--bottom': isTotemAccessibility ? '0px' : 'auto',
      'margin-top' : isTotemAccessibility ? '0px' : '50px'
    }"
  >
    <table>
      <tr>
        <td
          v-for="(item, index) in menus"
          :key="index"
          style="min-width:200px;"
        >
        <menu-item
          :index="index"
          :data="item"
        />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import constants from '@/constants'
import MenuItem from './MenuItem'
export default {
  components: {
    MenuItem
  },
  data () {
    return {
      menus: null
    }
  },
  computed: {
    ...mapState('app',['isTotemAccessibility']),
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.mainMenu.height + 'px'
    }
  },
  mounted () {
    api.getAll(`menus/totem-important`, false, null, null, null, utils.getDomain()).then(response => {
      console.log('response', utils.getDomain(), response)
      this.menus = response
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.main-menu {
  position: fixed;
  bottom: var(--bottom);
  margin-left: var(--sidebar-width);
  height: var(--height);
  width: 100%;
  overflow-x: scroll;
}
</style>
